if (!customElements.get('cp-featured-gallery')) {
  class CPFeaturedGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.root = this.closest('product-info');
      this.mainImage = this.querySelector('[data-cp-featured-main-image]');
      this.thumbnails = Array.from(this.querySelectorAll('[data-cp-featured-thumb]'));
      this.prevButton = this.querySelector('[data-cp-featured-prev]');
      this.nextButton = this.querySelector('[data-cp-featured-next]');

      this.preloadGalleryImages();

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => this.selectThumbnail(thumbnail));
      });

      this.prevButton?.addEventListener('click', () => this.navigate(-1));
      this.nextButton?.addEventListener('click', () => this.navigate(1));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data || data.sectionId !== this.root?.dataset.section || !data.variant) return;

          this.updateProductLinks(data.variant.id);

          const featuredMediaId = data.variant.featured_media?.id;
          if (!featuredMediaId) return;

          const matchingThumbnail = this.thumbnails.find(
            (thumbnail) => String(thumbnail.dataset.mediaId) === String(featuredMediaId)
          );

          if (matchingThumbnail) this.selectThumbnail(matchingThumbnail);
        });
      }
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
    }

    preloadGalleryImages() {
      this.preloadedImages = this.thumbnails.map((thumbnail) => {
        const image = new Image();
        const src = thumbnail.dataset.imageSrc;
        const srcset = thumbnail.dataset.imageSrcset;

        if (srcset) image.srcset = srcset;
        if (src) image.src = src;

        return image;
      });
    }

    navigate(direction) {
      if (this.thumbnails.length < 2) return;

      let currentIndex = this.thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
      if (currentIndex < 0) currentIndex = 0;

      const nextIndex = (currentIndex + direction + this.thumbnails.length) % this.thumbnails.length;
      this.selectThumbnail(this.thumbnails[nextIndex]);
    }

    selectThumbnail(thumbnail) {
      if (!this.mainImage || !thumbnail) return;

      if (thumbnail.classList.contains('is-active')) {
        this.setActiveThumbnail(thumbnail);
        return;
      }

      const nextSrc = thumbnail.dataset.imageSrc;
      const nextSrcset = thumbnail.dataset.imageSrcset;
      const nextAlt = thumbnail.dataset.imageAlt || '';
      if (!nextSrc) return;

      this.mainImage.classList.add('is-changing');
      this.mainImage.src = nextSrc;

      if (nextSrcset) {
        this.mainImage.srcset = nextSrcset;
      } else {
        this.mainImage.removeAttribute('srcset');
      }

      this.mainImage.alt = nextAlt;
      this.setActiveThumbnail(thumbnail);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.mainImage.classList.remove('is-changing'));
      });
    }

    setActiveThumbnail(selectedThumbnail) {
      this.thumbnails.forEach((thumbnail) => {
        const active = thumbnail === selectedThumbnail;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', String(active));
      });

      selectedThumbnail.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    updateProductLinks(variantId) {
      if (!this.root || !variantId || !this.root.dataset.url) return;

      const url = new URL(this.root.dataset.url, window.location.origin);
      url.searchParams.set('variant', variantId);
      const href = `${url.pathname}${url.search}`;

      this.root.querySelectorAll('[data-cp-featured-product-link]').forEach((link) => {
        link.href = href;
      });
    }
  }

  customElements.define('cp-featured-gallery', CPFeaturedGallery);
}
